import { render, staticRenderFns } from "./ShopJewelry.vue?vue&type=template&id=005d093e&scoped=true&"
import script from "./ShopJewelry.vue?vue&type=script&lang=js&"
export * from "./ShopJewelry.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "005d093e",
  null
  
)

export default component.exports